import { apiService } from '../api';
import { updateUserQuery, uploadAvatarQuery } from './interfaces';

const userService = apiService.injectEndpoints({
  endpoints: (builder) => ({
    updateUser: builder.mutation<
      updateUserQuery['response'],
      updateUserQuery['request']
    >({
      async queryFn(body, _api, _extraOptions, baseQuery) {
        const result = await baseQuery({
          url: `/user`,
          method: 'PATCH',
          body,
        });

        if (result.error) {
          return result;
        }
        const data = result.data as updateUserQuery['response'];
        data.avatar = data.avatar
          ? `${data.avatar}?${Date.now()}`
          : data.avatar;

        return { data };
      },
    }),
    uploadAvatarUser: builder.mutation<
      uploadAvatarQuery['response'],
      uploadAvatarQuery['request']
    >({
      query: ({ file }) => {
        const body = new FormData();
        body.append('file', file);
        return {
          url: `/user/upload-avatar`,
          method: 'POST',
          body,
        };
      },
    }),
  }),
});

export default userService;
